;(function () {

"use strict";

var LazyLoadView = Backbone.View.extend({
  initialize: function () {
    imagesLoaded(this.el, _.bind(this.imagesLoaded, this));
    this.start = new Date().getTime();
  },
  imagesLoaded: function () {
    var fin = new Date().getTime();
    var spread = fin - this.start;

    if (spread < 100) {
      this.$el.addClass('fast');
    }
    this.$el.addClass('active');
  }
});

module.exports = LazyLoadView;

}());